/**
 * used when a supervisor selects the unit they wish to subscribe/unsubscribe to
 * @param {Object} props container
 * @param {string} props.key id of the unit to change
 * @param {boolean} props.isSelected whether the element is initially selected
 * @param {Array} props.newUnitAlerts list of units to add to the user's selected alerts
 * @param {Function} props.setNewUnitAlerts setter for the stateful newUnitAlerts
 * @param {boolean} props.noSMS indicates whether supervisor should receive SMS alerts
 * @returns boolean indicating success or failure
 */
export const HandleSingleUnitClick = (props) => {
  const { key = null, isSelected = false, newUnitAlerts = [], setNewUnitAlerts = () => {}, noSMS = false } = props
  if (!isSelected) {
    const unitsToAdd = []
    const selection = key

    if (newUnitAlerts.selectedUnits.findIndex((assignedUnit) => assignedUnit === selection) === -1) {
      unitsToAdd.push(selection)
    }

    if (!noSMS) {
      setNewUnitAlerts({ ...newUnitAlerts, selectedUnits: [...newUnitAlerts.selectedUnits, ...unitsToAdd] })
    } else {
      setNewUnitAlerts({ ...newUnitAlerts, selectedUnits: [...newUnitAlerts.selectedUnits, ...unitsToAdd], sendEmail: true, isSubscribed: true })
    }
  } else {
    const tempAssigned = [...newUnitAlerts.selectedUnits]

    const deleteIndex = tempAssigned.findIndex((assignedUnit) => assignedUnit === key)
    if (deleteIndex !== -1) { tempAssigned.splice(deleteIndex, 1) }

    setNewUnitAlerts({ ...newUnitAlerts, selectedUnits: tempAssigned })
    return true
  }
}
